import * as React from 'react';
import { ArticleHeading1, UIText1 } from '@cian/ui-kit';

import * as styles from './styles.css';

import imgSrc from './assets/img.svg';

export const EmptyPage: React.FC = () => {
  return (
    <div className={styles['container']}>
      <div className={styles['wrapper']}>
        <div className={styles['img']}>
          <img src={imgSrc} />
        </div>

        <div className={styles['title']}>
          <ArticleHeading1>Нет данных по этому объекту</ArticleHeading1>
          <UIText1>
            Не смогли собрать сценарии получения дохода, потому что не достаточно данных для точной оценки объекта
          </UIText1>
        </div>
      </div>
    </div>
  );
};
